<template>
  <div class="vacancy-card-new"
  >
    <div class="vacancy-card-new__inner">
      <div v-if="vacancy.images.length"
           :class="mediaScrollSelector"
           class="vacancy-card-new__media-wrap "
      >
        <OverlayScrollbarsComponent ref="scroll"
                                    :options="mediaScrollbarOption"
                                    class="vacancy-card-new__media-inner"
        >
          <div v-for="(image, index) in vacancy.images"
               :key="image.id"
               class="vacancy-card-new__media-item "
          >
            <video v-if="isVideo(image)"
                   :title="createTitleMixin(vacancy.title, index === 0 ? null : index + 1, true)"
                   :alt="createAltMixin(vacancy.title, index === 0 ? null : index + 1, true)"
            >
              <source :src="image.path"
                      :type="image.type"
              >
              Your browser does not support the video tag.
            </video>
            <v-lazy-image v-else
                          :src="image.path"
                          :title="createTitleMixin(vacancy.title, index === 0 ? null : index + 1)"
                          :alt="createAltMixin(vacancy.title, index === 0 ? null : index + 1)"
                          use-picture
            >
              <source :srcset="image.path_webp" type="image/webp">
            </v-lazy-image>
          </div>

        </OverlayScrollbarsComponent>
      </div>
      <div v-else class="vacancy-card-new__media-wrap _no-photo">
        <img src="@/assets/img/png/no-photo-placeholder.png"
             :alt="vacancy.title"
             class="vacancy-card-new__media-placeholder"
        >
      </div>
      <div class="vacancy-card-new__main">
        <div class="vacancy-card-new__content">
          <div class="vacancy-card-new__header">
            <div v-if="vacancy.is_hot"
                 class="vacancy-card-new__label">
              <BaseSvg name="ico-hot"/>
            </div>
            <div class="vacancy-card-new__id ">ID: {{vacancy.id}}</div>
          </div>

          <div class="vacancy-card-new__title">
            <router-link-modified :to="{name: 'vacancy', params: {
                vacancyId: vacancy.slug,
                directionId: vacancy.direction_slug,
                categoryId: vacancy.category ? (vacancy.category || {}).slug : null
              }}"
            >
              {{vacancy.title}}
            </router-link-modified>
          </div>

          <CategoriesList v-if="false" :vacancy="vacancy"
                          class="vacancy-card-new__categories _no-slider "
          />

          <div class="vacancy-card-new__benefits benefits-list">
            <div class="benefits-list__item" :class="{_active: icons.observation}">
              <BaseSvg name="ico-thermometer"/>
            </div>
            <div class="benefits-list__item" :class="{_active: icons.housing}">
              <BaseSvg name="ico-house"/>
            </div>

            <div class="benefits-list__item" :class="{_active: icons.meals}">
              <BaseSvg name="ico-cutlery"/>
            </div>

            <div class="benefits-list__item" :class="{_active: icons.transport}">
              <BaseSvg name="ico-transport"/>
            </div>

            <div class="benefits-list__item" :class="{_active: icons.clothes}">
              <BaseSvg name="ico-t-shirt"/>
            </div>
          </div>

          <div class="vacancy-card-new__categories categories">
            <div class="categories__inner">
              <router-link-modified :to="{name: 'vacancies'}"
                                    class="categories__item"
              >
                <span>asd asdе</span>
              </router-link-modified>
              <router-link-modified :to="{name: 'vacancies'}"
                                    class="categories__item"
              >
                <span>asd asdasd asd</span>
              </router-link-modified>
              <router-link-modified :to="{name: 'vacancies'}"
                                    class="categories__item"
              >
                <span>Раasd</span>
              </router-link-modified>
              <router-link-modified :to="{name: 'vacancies'}"
                                    class="categories__item"
              >
                <span>asdasdasdasd</span>
              </router-link-modified>
              <router-link-modified :to="{name: 'vacancies'}"
                                    class="categories__item"
              >
                <span>asdasdasda asdsd</span>
              </router-link-modified>
              <router-link-modified :to="{name: 'vacancies'}"
                                    class="categories__item"
              >
                <span>asdasdasd</span>
              </router-link-modified>
            </div>
          </div>


          <div class="vacancy-card-new__salary">
            <div class="vacancy-card-new__salary-top">
              {{ salaryOriginal }}
              <sub>{{ salaryCurrencyOriginal }}</sub>
              <!--              <sub>{{ salaryCurrencyOriginal }}/{{ salaryPerType }}</sub>-->
            </div>
            <div class="vacancy-card-new__salary-bottom" v-if="false">(1232-3002 zl/неделя)</div>
            <div class="vacancy-card-new__salary-info">
              <BaseSvg name="ico-info-2"
                       width="1.1rem"
                       height="1.1rem"
              />
              <div class="vacancy-card-new__salary-info-tooltip">
                <div class="text">
                  <p>{{ $tVacancy('Salary shown is net. That is, what the employee will receive in his hands') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vacancy-card-new__side-mob">
          <div class="vacancy-card-new__employer">
            <div class="vacancy-card-new__employer-logo-wrap">
              <v-lazy-image v-if="vacancy.employer_profile && vacancy.employer_profile.company_logo"
                            :src="vacancy.employer_profile.company_logo"
                            :title="createTitleMixin(vacancy.employer_profile.name)"
                            :alt="createAltMixin(vacancy.employer_profile.name)"
                            use-picture
              >
                <source :srcset="vacancy.employer_profile.company_logo_webp" type="image/webp">
              </v-lazy-image>
              <BaseSvg v-else name="ico-avatar"/>
            </div>
            <div class="vacancy-card-new__employer-top">
              <div class="vacancy-card-new__employer-label">{{ $tVacancy('Vacancy from') }}</div>
              <div class="vacancy-card-new__rating" v-if="false">
                <div class="vacancy-card-new__rating-stars">
                  <BaseSvg name="ico-star"
                           class="_active"
                  />
                  <BaseSvg name="ico-star"
                           class="_active"
                  />
                  <BaseSvg name="ico-star"
                           class="_active"
                  />
                  <BaseSvg name="ico-star"/>
                  <BaseSvg name="ico-star"/>
                </div>
                <BaseHelp class="vacancy-card-new__side-help"
                          value="Some text by props value"
                />
              </div>
            </div>
            <div class="vacancy-card-new__employer-name">
              <abbr>{{vacancy.employer_profile && (vacancy.employer_profile.short_name ||
                vacancy.employer_profile.name)}}</abbr>
              <BaseSvg class="vacancy-card-new__employer-name-badge" name="ico-check-outline"/>
            </div>
          </div>

          <div class="vacancy-card-new__side-links">
            <router-link-modified
              :to="{ name: 'company-info', params: { companySlug: (vacancy.employer_profile || {}).slug || (vacancy.employer_profile || {}).customer_id}}"
              tag="div"
              class="vacancy-card-new__side-link inline-link"
            >
              <span>{{$tVacancy('Dossier')}}</span>&nbsp;<BaseSvg name="ico-arrow-light"
                                                                  class="_arrow"
            />
            </router-link-modified>
            <router-link-modified
              :to="{name: 'vacancies', query: {customer_id: (vacancy.employer_profile || {}).customer_id}}"
              class="vacancy-card-new__side-link inline-link"
            >
            <span>{{$tVacancies('All company vacancies')}}
              <!--({{vacancy.employer_profile && vacancy.employer_profile.employee_count}})--></span>&nbsp;
              <BaseSvg name="ico-arrow-light"
                       class="_arrow"
              />
            </router-link-modified>
            <router-link-modified
              to="#"
              tag="a"
              class="vacancy-card-new__side-link inline-link"
              v-if="false"
            >
              <span>{{$tVacancy('Reviews')}}</span>&nbsp;<BaseSvg name="ico-arrow-light"
                                                                  class="_arrow"
            />
            </router-link-modified>
          </div>
        </div>

        <VacancyCardAction
          class="vacancy-card-new__action"
          :vacancy="vacancy"
        />
      </div>
      <div v-if="vacancy.employer_profile" class="vacancy-card-new__side">
        <div class="vacancy-card-new__side-header">
          <div class="vacancy-card-new__employer">
            <div class="vacancy-card-new__employer-logo-wrap">
              <v-lazy-image v-if="vacancy.employer_profile && vacancy.employer_profile.company_logo"
                            :src="vacancy.employer_profile.company_logo"
                            :title="createTitleMixin(vacancy.employer_profile.name)"
                            :alt="createAltMixin(vacancy.employer_profile.name)"
                            use-picture
              >
                <source :srcset="vacancy.employer_profile.company_logo_webp" type="image/webp">
              </v-lazy-image>
              <BaseSvg v-else name="ico-avatar"/>
            </div>
            <div class="vacancy-card-new__employer-top">
              <div class="vacancy-card-new__employer-label">{{ $tVacancy('Vacancy from') }}</div>
            </div>

            <div class="vacancy-card-new__employer-name">
              <abbr v-if="vacancy.employer_profile && (vacancy.employer_profile.short_name || vacancy.employer_profile.name)">{{vacancy.employer_profile && (vacancy.employer_profile.short_name || vacancy.employer_profile.name)}}</abbr>
              <abbr v-else>{{$tVacancy('No name')}}</abbr>
              <BaseSvg class="vacancy-card-new__employer-name-badge" name="ico-check-outline"/>
            </div>
          </div>

          <div class="vacancy-card-new__side-links">
            <router-link-modified
              :to="{ name: 'company-info', params: { companySlug: (vacancy.employer_profile || {}).slug || (vacancy.employer_profile || {}).customer_id}}"
              tag="div"
              class="vacancy-card-new__side-link inline-link"
            >
              <span>{{$tVacancy('Dossier')}}</span>&nbsp;<BaseSvg name="ico-arrow-light"
                                                                  class="_arrow"
            />
            </router-link-modified>
            <router-link-modified
              :to="{name: 'vacancies', query: {customer_id: (vacancy.employer_profile || {}).customer_id}}"
              class="vacancy-card-new__side-link inline-link"
            >
            <span>{{$tVacancies('All company vacancies')}}
              <!--({{vacancy.employer_profile && vacancy.employer_profile.employee_count}})--></span>&nbsp;
              <BaseSvg name="ico-arrow-light"
                       class="_arrow"
              />
            </router-link-modified>
          </div>
        </div>

        <div class="vacancy-card-new__side-footer" v-if="false">
          <div class="vacancy-card-new__rating-wrap" >
            <div class="vacancy-card-new__employer-label">
              <span>{{ $tVacancy('Assessment of applicants') }}</span>
              <BaseHelp class="vacancy-card-new__side-help"
                        value="Some text by props value"
              />
            </div>
            <div class="vacancy-card-new__rating">
              <div class="vacancy-card-new__rating-stars">
                <BaseSvg name="ico-star"
                         class="_active"/>
                <BaseSvg name="ico-star"
                         class="_active"/>
                <BaseSvg name="ico-star"
                         class="_active"/>
                <BaseSvg name="ico-star"/>
                <BaseSvg name="ico-star"/>
              </div>
            </div>
          </div>
          <div class="vacancy-card-new__side-links">
            <router-link-modified
              to="#"
              tag="a"
              class="vacancy-card-new__side-link inline-link"
            >
              <span>{{$tVacancy('Reviews')}}</span>&nbsp;<BaseSvg name="ico-arrow-light"
                                                                  class="_arrow"
            />
            </router-link-modified>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'overlayscrollbars/css/OverlayScrollbars.css';
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue';
  import {VIDEOS_MIME_TYPES} from '../constants/files';
  import CategoriesList from './CategoriesList_Old';
  import VacancyCardAction from './VacancyCardAction';

  export default {
    name: 'VacancyCard',
    components: {
      VacancyCardAction,
      CategoriesList,
      OverlayScrollbarsComponent
    },
    props: {
      vacancy: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        scroll: null
      };
    },
    computed: {
      currencies() {
        return this.$store.state.currencies;
      },
      currentCurrency() {
        return this.$store.state.currentCurrency;
      },
      mediaScrollSelector() {
        if (!this.scroll) return null;

        if (this.scroll.trackLength.y === this.scroll.handleLength.y) {
          return '_scroll-hidden';
        }

        const progress = this.scroll.ratio.y;

        if (progress === 0) {
          return '_scroll-start';
        }
        if (progress === 1) {
          return '_scroll-end';
        }

        return null;
      },
      mediaScrollbarOption() {
        return {
          callbacks: {
            onScroll: this.checkScroll,
            onUpdated: this.checkScroll,
            onHostSizeChanged: this.checkScroll
          }
        };
      },

      salaryOriginal() {
        if ((this.vacancy || {}).salary_from) {
          return `${Math.floor((this.vacancy || {}).salary_from)} - ${Math.floor((this.vacancy || {}).salary_to)}`;
        }

        return Math.floor((this.vacancy || {}).salary_fix);
      },

      salaryCurrencyOriginal() {
        return (this.currencies.find((cur) => this.vacancy.currency_id === cur.id) || {}).symbol;
      },

      salaryPerType() {
        return (((this.vacancy || {}).salary_type || {}).name || '').toLowerCase();
      },

      icons() {
        const vacancy = this.vacancy;

        return {
          observation: !!(vacancy.conditions_observation_housing || vacancy.conditions_observation_housing_type),
          housing: !!(vacancy.conditions_housing || vacancy.conditions_housing_type || vacancy.conditions_housing_description),
          meals: !!(vacancy.conditions_meals || vacancy.conditions_meals_type),
          transport: !!(vacancy.conditions_transport || vacancy.conditions_transport_type),
          clothes: !!(vacancy.conditions_clothes || vacancy.conditions_clothes_type)
        };
      },
    },
    methods: {
      checkScroll() {
        const instance = this.$refs['scroll'] && this.$refs['scroll']._osInstace;

        if (!instance) {
          return this.progress = null;
        }

        this.scroll = instance.scroll();
        // if(this.progress === 0) {
        //   this.$refs['scroll'].$el.classList.add('_scroll-start')
        // } else {
        //   this.$refs['scroll'].$el.classList.remove('_scroll-start')
        // }
        //
        // if (this.progress === 1) {
        //   this.$refs['scroll'].$el.classList.add('_scroll-end')
        // } else {
        //   this.$refs['scroll'].$el.classList.remove('_scroll-end')
        // }
      },
      isVideo(file) {
        return VIDEOS_MIME_TYPES.includes(file.type);
      }
      // onVacancyClick(e) {
      //   if (!e.target.closest('a, input, button, .')) {
      //     this.$router.push({
      //       name: 'vacancy',
      //       params: {
      //         vacancyId: this.vacancy.slug,
      //         directionId: this.vacancy.direction_slug,
      //         categoryId: this.vacancy.category ? this.vacancy.category.slug : null
      //       }
      //     });
      //   }
      // }
      // createTagRoute(item) {
      //   if(item.param_type === 'static') {
      //     return {
      //       name: 'vacancies-with-filters',
      //       params: {
      //         directionId: this.vacancy.direction_id.slug,
      //         categoriesIds: [this.vacancy.category_id.category.slug],
      //         filters: [item.param + '-' + item.param_value]
      //       }
      //     }
      //   } else {
      //     return {
      //       name: 'vacancies-with-dynamic',
      //       params: {
      //         directionId: this.vacancy.direction_id.slug,
      //         categoriesIds: [this.vacancy.category_id.category.slug],
      //         dynamic: [item.param + '-' + item.param_value]
      //       }
      //     }
      //   }
      // }
    },
    mounted() {
      this.checkScroll();
    }
  };
</script>

<style>

</style>
